<ng-container *ngIf="rowData">
    <div class="brand-selection-table-container">
        <ag-grid-angular
            class="brand-selection-table-grid ag-theme-alpine"
            style="width: 100%; height: 100%;"
            [rowData]="rowData"
            [columnDefs]="colDefs"
            [modules]="modules"
            [theme]="theme"
            [gridOptions]="gridOptions">
        </ag-grid-angular>
        <div class="grid-bottom-fade"></div>
    </div>
</ng-container>